import classNames from 'classnames';
import { useFormikContext } from 'formik';
import { TooltipProps } from 'modules/tournaments/ui/components/form-parts/rules/components/fields/types';
import UDFormDateInput, { UDFormDateInputProps } from '.';

type Props = {
  startName: string;
  endName: string;
  startLabel?: string;
  endLabel?: string;
  startTooltip?: TooltipProps;
  endTooltip?: TooltipProps;
  highlightStart?: boolean;
  highlightEnd?: boolean;
} & Omit<UDFormDateInputProps, 'name' | 'label' | 'highlight'>;

const UDFormDateRange = (props: Props) => {
  const {
    startName,
    endName,
    startLabel,
    endLabel,
    startTooltip,
    endTooltip,
    labelProps,
    containerProps,
    disabled,
    minDate,
    autoComplete,
    highlightStart,
    highlightEnd,
  } = props;

  const { getFieldProps } = useFormikContext();

  const selectedStart = getFieldProps(startName).value;
  const selectedEnd = getFieldProps(endName).value;
  const startMinDate = minDate || null;
  const endMinDate = selectedStart || minDate || null;

  return (
    <div {...containerProps} className={classNames('flex justify-between', containerProps?.className)}>
      <UDFormDateInput
        disabled={disabled}
        name={startName}
        containerProps={{ className: 'w-45', style: { maxWidth: 213 } }}
        wrapperClassName="w-full"
        label={startLabel}
        tooltip={startTooltip?.tooltip}
        tooltipProps={startTooltip?.tooltipProps}
        labelProps={labelProps}
        minDate={startMinDate}
        maxDate={selectedEnd}
        autoComplete={autoComplete}
        highlight={highlightStart}
      />
      <UDFormDateInput
        disabled={disabled}
        name={endName}
        containerProps={{ className: 'w-45', style: { maxWidth: 213 } }}
        wrapperClassName="w-full"
        label={endLabel}
        tooltip={endTooltip?.tooltip}
        tooltipProps={endTooltip?.tooltipProps}
        labelProps={labelProps}
        minDate={endMinDate}
        autoComplete={autoComplete}
        highlight={highlightEnd}
      />
    </div>
  );
};

export default UDFormDateRange;
